import { MinimalLocationInfo } from "@/models/location/MinimalLocationInfo";

export class ControlCenterInfo{
    id:number = -1;
    syncId?:string = undefined;
    name:string = "";
    phoneNumber:string = "";
    locations:Array<MinimalLocationInfo> = [];
}
